exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bibleCloudBookSelector-menu[data-v-aaf11396] {\n  margin: 25px 25px 0 25px;\n}\n.bibleCloudBookSelector-section-title-disabled[data-v-aaf11396] {\n  opacity: 0.4;\n}\n.bibleCloudBookSelector-book[data-v-aaf11396] {\n  color: #111;\n  display: block;\n  margin: 8px 0;\n  padding: 0 11px;\n  text-decoration: none;\n}\n.bibleCloudBookSelector-book[data-v-aaf11396]:hover {\n  background: #eff1f6;\n}", ""]);

// exports
